export enum DialogState {
    hide,
    form,
    result
}
